import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { SavedLocationsApi } from "@freightsimple/generated-dashboard-openapi-client/apis/SavedLocationsApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useSavedLocationsApi(): SavedLocationsApi {
  const { accessToken } = useAuthentication();

  return new SavedLocationsApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
